// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1oYAF","amount":"Amount_amount__2udrG","tip":"Amount_tip__146XH","tipHeader":"Amount_tipHeader__3EH-M","tipsWrap":"Amount_tipsWrap__1Ag45"};